module.exports = __webpack_public_path__ + "components/media-kit/static/icon-facebook-89f104cc3b74b6edf9b24e7223c01ba5.svg";